import { Cta, Reveal } from "@/components/landing/Shared";
import { PaymentPlans } from "./PaymentPlans";

export const Lost = () => (
  <section className="bg-[var(--blush)] px-5 py-24 text-center sm:px-8 lg:py-32" data-testid="section-lost">
    <div className="mx-auto max-w-4xl">
      <Reveal>
        <h2 className="font-display text-[2.1rem] font-light leading-[1.15] tracking-tight [text-wrap:balance] sm:text-5xl" data-testid="lost-heading">
          You're not stuck forever. <em className="mt-2 inline-block -rotate-1 bg-[var(--mauve)] px-3 py-1 text-white [text-wrap:balance]">You just haven't found your next step yet.</em>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-12">
        <PaymentPlans />
      </Reveal>
      <Reveal className="mx-auto mt-12 max-w-2xl space-y-4 text-lg leading-relaxed text-[var(--ink)] sm:text-xl">
        <p className="[text-wrap:balance]">6 months will pass either way. The question is, will you still be in the same place?</p>
        <p className="font-display text-3xl italic text-[var(--mauve-dark)]">Your next chapter starts now.</p>
      </Reveal>
      <Reveal className="mt-10"><Cta testId="lost-cta-button" label="Yes, show me how" href="#get-access" /></Reveal>
    </div>
  </section>
);
